import { v as bvVar } from 'bv';
import { contains, partial } from 'underscore';

export default partial(contains, bvVar('betBuilderMarketTypeIds'));
